import { unloadedAsyncState } from "widgets-for-react";
import { emptyFragment } from "../../../utils/react";
import { initialDetailsFilterProps } from "./EventFilters/EventFiltersState";
export const initialVisibleMoments = 10;
export const initialEventDetailsState = {
    eventId: null,
    event: unloadedAsyncState(),
    Jumbo: emptyFragment,
    filters: initialDetailsFilterProps
};
